import { render, staticRenderFns } from "./ObjectDashAdmin.vue?vue&type=template&id=0478127f&scoped=true"
import script from "./ObjectDashAdmin.vue?vue&type=script&lang=ts"
export * from "./ObjectDashAdmin.vue?vue&type=script&lang=ts"
import style0 from "./ObjectDashAdmin.vue?vue&type=style&index=0&id=0478127f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0478127f",
  null
  
)

export default component.exports